import { PlaceholderSegment } from '@britishcouncil/react-admin';
import { Centered } from 'components';

export const ChooseCentreToUseEventPlannerPlaceholder = () => {
  return (
    <Centered>
      <PlaceholderSegment icon="info" info title="Please choose an area to use Event Planner" />
    </Centered>
  );
};
